import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { resetDataFC_09 } from '../../redux/DucksBeneficiario/FC_09Ducks'
import { resetDataFC_33 } from '../../redux/DucksBeneficiario/FC_33Ducks'
import { resetDataFC_30 } from '../../redux/DucksBeneficiario/FC_30Ducks'
import { resetDataFC_05 } from '../../redux/DucksBeneficiario/FC_05Ducks'
import { resetDataFC_35 } from '../../redux/DucksBeneficiario/FC_35Ducks'
import { resetDataFC_06 } from '../../redux/DucksBeneficiario/FC_06Ducks'
import { resetDataFC_08 } from '../../redux/DucksBeneficiario/FC_08Ducks'
import { resetDataFC_40 } from '../../redux/DucksBeneficiario/FC_40Ducks'
import { resetDataFC_34 } from '../../redux/DucksBeneficiario/FC_34Ducks'
import { resetDataFC_41 } from '../../redux/DucksBeneficiario/FC_41Ducks'
import { resetDataFC_31 } from '../../redux/DucksBeneficiario/FC_31Ducks'
import { resetDataFC_36 } from '../../redux/DucksBeneficiario/FC_36Ducks'
{/* LOGOS EN NEGRO */ }
import Menu from '../../img/Menu.png';
import ServiciosVarios from '../../img/ServiciosVarios.png';
import usodemarca from '../../img/usodemarca.png';
import query from '../../img/query.png';
import request1 from '../../img/request1.png';
import exportacion from '../../img/export.png';
import perfilUser from '../../img/perfilUser.png';
import ventaNacional from '../../img/ventaNacional.png';
import trasladoroducto from '../../img/trasladoProducto.png'
import registroMaguey from '../../img/registroMaguey.png'
import Holograma from '../../img/Holograma.png'
import RenovacionCertificado from '../../img/RenovacionCertificado.png'
import productosMezcal from '../../img/productosMezcal.png'
import SuspensionReactivacion from '../../img/SuspensionReactivacion.png'
import seguimiento from '../../img/seguimiento.png'
import actualizacion from '../../img/actualizacion.png'
import Dictamenes from '../../img/dictamenes.png'
import Certificado from '../../img/certificado.png'
import Solicitudes from '../../img/solicitud.png'
import { useDispatch, useSelector } from 'react-redux'
import {
    obtenerSolicitudesWithStatus, obtenerSolicitudesWithStatusProceso,
    Contadorfc_01PorLogin
} from '../../redux/SolicitudesDucks'
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado, obtenerTodasLasSolicitudesWithStatusEnviado, obtenerTodosClientes } from '../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
} from "react-router-dom";

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
    faFilePdf, faAddressCard
} from '@fortawesome/free-solid-svg-icons'
import { obtenerCliente, obtenerUserPorEmail } from '../../redux/UsuarioDucks';
import { obtenerClienteConDetalle } from '../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../redux/AppDucks'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket, faAddressCard,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faFilePdf)


const { useState } = React;



const MenuHamburguesaBebeficiario = (props) => {

    const myRef = useRef(null)
    const myRefMobile = useRef(null)

    const currentUser = useSelector(store => store.Usuario.data)
    const cadenaProductiva = useSelector(store => store.Cliente.cadenaProductiva)
    const contadorSolicitud = useSelector(store => store.Solicitudes.contadorSolicitud)
    const dataUser = useSelector(store => store.Usuario.user)
    //const solicitudesStatus = useSelector(store => store.AtencionSolicitud.status)
    const solicitudesStatusBeneficiario = useSelector(store => store.Solicitudes.status)

    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    let idRol = 0
    let usuario = ''
    if (currentUser) {
        idUsuario = currentUser.user[0].id
        idRol = currentUser.user[0].rol
        usuario = currentUser.user[0].user
    }
    React.useEffect(() => {
        dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
    }, [])

    const pages = ['Borrador', 'Documentos pendientes', 'Enviadas', 'En proceso', 'Aceptadas', 'Información Comercial'];
    const [claseToggle, setclaseToggle] = useState('');
    const [claseNav, setclaseNav] = useState('');
    const [claseBodyPD, setclaseBodyPD] = useState('');
    const [claseHeaderPD, setHeaderPD] = useState('');
    const [overOverFlowDinamico, setOverFlowDinamico] = useState('');
    const [claseDisplay, setclaseDisplay] = useState('none');
    const [claseScrollTop, setScrollTop] = useState('unset');



    const estilos1 = '#c88b3e';
    const estilos0 = '#2b2b2b';

    const [isActiva1, setIsActiva1] = React.useState(estilos0);
    const [isActiva2, setIsActiva2] = React.useState(estilos0);
    const [isActiva3, setIsActiva3] = React.useState(estilos0);
    const [isActiva4, setIsActiva4] = React.useState(estilos0);
    const [isActiva5, setIsActiva5] = React.useState(estilos0);
    const [isActiva6, setIsActiva6] = React.useState(estilos0);

    const dispatch = useDispatch()
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [activeStep, setActiveStep] = React.useState(0);
    let serviciosConComercamRutasBasic
    if (contadorSolicitud === 0) {
        serviciosConComercamRutasBasic = [
            { text: 'Solicitud de inscripción', ruta: '/fc_01', source: request1 }
        ]
    } else {
        serviciosConComercamRutasBasic = [

        ]
    }
    React.useEffect(async () => {
        await activarOpcionMenuBeneficiario()
    }, [solicitudesStatusBeneficiario])


    const activarOpcionMenuBeneficiario = async () => {
        switch (Number(solicitudesStatusBeneficiario)) {
            case 1:
                setIsActiva1(estilos1);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                break
            case 2:
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos1);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                break
            case 3 || 5 || 6 || undefined:
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos1);
                setIsActiva5(estilos0);
                break
            case 4:
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos1);
                break
            // case 5:
            //     setIsActiva1(estilos0);
            //     setIsActiva2(estilos0);
            //     setIsActiva3(estilos1);
            //     setIsActiva4(estilos0);
            //     setIsActiva5(estilos0);
            // break
            case 7:
                setIsActiva1(estilos0);
                setIsActiva2(estilos1);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                break
            default:
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                break
        }
    }

    const [serviciosConComercamRutasPremium, setServiciosConComercamRutasPremium] = React.useState([])
    const serviciosConComercamRutasConsulta = [{ text: 'Consulta de Asociados', ruta: '/PanelConsulta', source: query }]

    const [serviciosPremium, setServiciosPremium] = React.useState([])

    const [modal, setModal] = React.useState(false);
    React.useEffect(() => {
        const solicitudes = []
        const servicios = []
        if (cadenaProductiva) {

            if (cadenaProductiva["Comercializador de mezcal"] === true) {
                solicitudes.push({ text: 'Solicitud de exportación', ruta: '/fc_09', source: exportacion, modal: false })
            } else {
                solicitudes.push({ text: 'Solicitud de exportación', ruta: '/modal', source: exportacion, modal: true })
            }

            if (cadenaProductiva["Comercializador de mezcal"] === true) {
                solicitudes.push({ text: 'Solicitud de envasado nacional', ruta: '/fc_33', source: ventaNacional, modal: false })
            } else {
                solicitudes.push({ text: 'Solicitud de envasado nacional', ruta: '/modal', source: ventaNacional, modal: true })
            }

            if (cadenaProductiva["Envasador"] === true || cadenaProductiva["Productor de Mezcal"] === true ||
                cadenaProductiva["Comercializador de bebidas con mezcal"] === true || cadenaProductiva["Comercializador de mezcal"] === true) {
                solicitudes.push({ text: 'Traslado de producto', ruta: '/fc_30', source: trasladoroducto, modal: false })
            } else {
                solicitudes.push({ text: 'Traslado de producto', ruta: '/modal', source: trasladoroducto, modal: true })
            }
            solicitudes.push({ text: 'Uso de marca COMERCAM', ruta: '/fc_05', source: usodemarca, modal: false })
            solicitudes.push({ text: 'Servicios varios', ruta: '/fc_35', source: ServiciosVarios, modal: false })

            if (cadenaProductiva["Productor de maguey"] === true || cadenaProductiva["viverista"] === true) {
                solicitudes.push({ text: 'Registro de maguey', ruta: '/fc_06', source: registroMaguey, modal: false })
            } else {
                solicitudes.push({ text: 'Registro de maguey', ruta: '/modal', source: registroMaguey, modal: true })
            }
            solicitudes.push({ text: 'Renovación de certificados', ruta: '/fc_08', source: RenovacionCertificado, modal: false })
            solicitudes.push({ text: 'Compra de hologramas', ruta: '/fc_40', source: Holograma, modal: false })

            solicitudes.push({ text: 'Suspensión y reactivación', ruta: '/fc_34', source: SuspensionReactivacion })

            if (cadenaProductiva["Comercializador de bebidas con mezcal"] === true || cadenaProductiva["Envasador"] === true ||
                cadenaProductiva["Productor de Mezcal"] === true || cadenaProductiva["Comercializador de mezcal"] === true) {
                solicitudes.push({ text: 'Solicitud de seguimiento', ruta: '/fc_31', source: seguimiento, modal: false })
            } else {
                solicitudes.push({ text: 'Solicitud de seguimiento', ruta: '/fc_31', source: seguimiento, modal: true })
            }
            if (cadenaProductiva["Comercializador de bebidas con mezcal"] === true) {
                solicitudes.push({ text: 'Solicitud de bebidas con mezcal', ruta: '/fc_41', source: productosMezcal, modal: false })
            } else {
                solicitudes.push({ text: 'Solicitud de bebidas con mezcal', ruta: '/fc_41', source: productosMezcal, modal: true })
            }
            solicitudes.push({ text: 'Solicitud de actualización', ruta: '/fc_36', source: actualizacion, modal: true })

            //servicios.push({ text: 'Certificados', ruta: '/CertificadosBeneficiarioComponent', source: Certificado })
        }

        setServiciosConComercamRutasPremium(solicitudes)
        setServiciosPremium(servicios)
    }, [cadenaProductiva])
    const serviciosConComercamRutasBasicToolTips = ['Tooltip 1']


    const serviciosDictamen = [
        { text: 'Dictamenes', ruta: '/SolicitudesDictamenesComponent', source: Dictamenes }
    ]
    const limpiarShadows = () => {

        setIsActiva1(estilos0);
        setIsActiva2(estilos0);
        setIsActiva3(estilos0);
        setIsActiva4(estilos0);
        setIsActiva5(estilos0);
        setIsActiva6(estilos0);
    }

    const agregarClasesToggle = async (item) => {
        if (item.text === 'Solicitud de envasado nacional') await dispatch(resetDataFC_33())
        if (item.text === 'Solicitud de exportación') await dispatch(resetDataFC_09())
        if (item.text === 'Traslado de producto') await dispatch(resetDataFC_30())
        if (item.text === 'Uso de marca COMERCAM') await dispatch(resetDataFC_05())
        if (item.text === 'Servicios varios') await dispatch(resetDataFC_35())
        if (item.text === 'Registro de maguey') await dispatch(resetDataFC_06())
        if (item.text === 'Renovación de certificados') await dispatch(resetDataFC_08())
        if (item.text === 'Compra de hologramas') await dispatch(resetDataFC_40())
        if (item.text === 'Suspensión y reactivación') await dispatch(resetDataFC_34())
        if (item.text === 'Solicitud de bebidas con mezcal') await dispatch(resetDataFC_41())
        if (item.text === 'Solicitud de seguimiento') await dispatch(resetDataFC_31())
        if (item.text === 'Solicitud de actualización') await dispatch(resetDataFC_36())
        if (claseBodyPD === '' && claseNav === '' && claseBodyPD === '' && claseHeaderPD === '') {
            setclaseToggle('bx-x');
            setclaseNav('show');
            setclaseBodyPD('body-pd');
            setHeaderPD('body-pd');
            setOverFlowDinamico('scroll');
            setclaseDisplay('contents');
            limpiarShadows();

            //alert('Abierto con:' + claseBodyPD + claseNav + claseBodyPD + claseHeaderPD)
        }
    }

    const cerrarToggle = async () => {
        setclaseToggle('');
        setclaseNav('');
        setclaseBodyPD('');
        setHeaderPD('');
        setOverFlowDinamico('hidden')
        setclaseDisplay('none');
        limpiarShadows();
    }

    const agregarClasesToggleMobile = () => {
        if (claseBodyPD === '' && claseNav === '' && claseBodyPD === '' && claseHeaderPD === '') {
            setclaseToggle('bx-x');
            setclaseNav('show');
            setclaseBodyPD('body-pd');
            setOverFlowDinamico('scroll');
            setclaseDisplay('contents');
            limpiarShadows();
        }
        else {
            setclaseToggle('');
            setclaseNav('');
            setclaseBodyPD('');
            setHeaderPD('');
            setOverFlowDinamico('hidden')
            setclaseDisplay('none');
            limpiarShadows();
        }
    }


    const handleMenuOptionDesk = async (page, index) => {
        setActiveStep(index)
        setAnchorElNav(null);
        let res
        switch (page) {
            case 'Borrador':
                setIsActiva1(estilos1);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                await dispatch(obtenerTodosClientes())
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'Documentos pendientes':
                setIsActiva1(estilos0);
                setIsActiva2(estilos1);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                await dispatch(obtenerTodosClientes())
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'Enviadas':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos1);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                await dispatch(obtenerTodosClientes())
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'En proceso':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos1);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                await dispatch(obtenerTodosClientes())
                res = await dispatch(obtenerSolicitudesWithStatusProceso({ status1: 3, status2: 5, status3: 6, idLogin: idUsuario }))

                // let res3 = await dispatch(obtenerSolicitudesWithStatus({ status: 3, idLogin: idUsuario }))

                props.history.push('/solicitudes')
                return
            case 'Aceptadas':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos1);
                setIsActiva6(estilos0);
                await dispatch(obtenerTodosClientes())
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 4, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'Información Comercial':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos1);
                props.history.push('/informacion_comercial')
                return
            default:
                // props.history.push('/fc_01')
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
        }
    }
    const handleMenuOptionDeskBasic = async (page, index) => {
        setActiveStep(index)
        setAnchorElNav(null);
        let res
        switch (page) {
            case 'Borrador':
                setIsActiva1(estilos1);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'Documentos pendientes':
                setIsActiva1(estilos0);
                setIsActiva2(estilos1);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'Enviadas':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos1);
                setIsActiva4(estilos0);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'En proceso':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos1);
                setIsActiva5(estilos0);
                setIsActiva6(estilos0);
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatusProceso({ status1: 3, status2: 5, status3: 6, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            case 'Aceptadas':
                setIsActiva1(estilos0);
                setIsActiva2(estilos0);
                setIsActiva3(estilos0);
                setIsActiva4(estilos0);
                setIsActiva5(estilos1);
                setIsActiva6(estilos0);
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 4, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
            default:
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                res = await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
                props.history.push('/solicitudes')
                return
        }
    }

    const toolTips2 = [

        { text: 'Solicitud de inscripción', ruta: '/fc_01' },
        { text: 'Uso de marca COMERCAM', ruta: '/fc_05' },
        { text: 'Registro de maguey', ruta: '/fc_06' },
        { text: 'Renovación de certificados', ruta: '/fc_08' },
        { text: 'Certificado de exportación', ruta: '/fc_09' },
        { text: 'Traslado de producto', ruta: '/fc_30' },
        { text: 'Inspección en: Ajuste de grado, Muestra, Muestreo, Ingreso y Liberación de maduración', ruta: '/fc_31' },
        { text: 'Certificado de venta nacional', ruta: '/fc_33' },
        { text: 'Suspensión y reactivación', ruta: '/fc_34' },
        { text: 'Servicios varios', ruta: '/fc_35' },
        { text: 'Solicitud de actualización', ruta: '/fc_36' },
        { text: 'Compra de hologramas', ruta: '/fc_40' },
        { text: 'Solicitud para productos con mezcal', ruta: '/fc_41' }
    ]

    //PARA DETECTAR EL CLICK Y CERRAR EL MENÚ
    const catMenu = useRef(null)

    const closeOpenMenus = (e) => {
        if (catMenu.current && !catMenu.current.contains(e.target) && claseBodyPD != '' && claseNav != '' && claseBodyPD != '' && claseHeaderPD != '') {

            cerrarToggle();
        }
    }
    const perfilusuario = async () => {
        let dataCliente = await dispatch(obtenerCliente(currentUser.user?.[0].id))
        console.log('los datos de data es ', dataCliente)
        if (dataCliente) {
            await dispatch(actualizarLoadingApp_true());
            await dispatch(obtenerClienteConDetalle(dataCliente?.data?.data?.idcliente));
            await dispatch(actualizarLoadingApp_false());
        }
        props.history.push('/perfil_usuario')
    }
    const certificados = () => {
        props.history.push('/CertificadosBeneficiarioComponent')
    }

    document.addEventListener('mousedown', closeOpenMenus);



    return (
        <Fragment>
            <div style={{ scrollBehavior: claseScrollTop }} className={`body2 scrollbar ${claseBodyPD}`} id='body-pd' >
                <header className={`header ${claseHeaderPD}`} id='header'>
                    <div className='header_toggle' >
                    </div>
                    <div className='text-center'>
                        {(props.idUsuario === 2 || props.idUsuario === 1 || props.idUsuario === 7) &&
                            <button style={{ border: 'none', backgroundColor: '#2b2b2b', color: 'white', fontFamily: 'Montserrat', float: 'left', marginLeft: '-60%' }}
                                onClick={() => { perfilusuario() }} className="botonZoom"> <img src={perfilUser} style={{ width: '25px', transform: 'scale(1.5)' }} /><br />Perfil</button>}
                        <a ref={catMenu} onClick={agregarClasesToggleMobile} href='#' className='a2 text-center logoEscondido' style={{ color: 'white', width: '30px' }}>
                            <img id="imagenLogoMaguey" className="img-fluid" src={Menu}></img>
                        </a>
                        {props.idUsuario === 2 ? (
                            <Fragment>
                                <span className='text-center textoEscondido'><strong> Bienvenido a COMERCAM en línea</strong></span>
                                <br className='textoEscondido'></br><br></br>

                                <Tooltip title="Borrador" arrow>
                                    <button style={{ backgroundColor: isActiva1 }} onClick={e => handleMenuOptionDesk(pages[0], 0)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br /> Borrador</button>
                                </Tooltip>
                                <Tooltip title="Documentos pendientes" arrow>
                                    <button style={{ backgroundColor: isActiva2 }}
                                        onClick={e => handleMenuOptionDesk(pages[1], 1)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faFilePdf} /> <br />Documentos pendientes</button>
                                </Tooltip>
                                <Tooltip title="Enviadas" arrow>
                                    <button style={{ backgroundColor: isActiva3 }}
                                        onClick={e => handleMenuOptionDesk(pages[2], 2)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEnvelope} /> <br />Enviadas</button>
                                </Tooltip>

                                <Tooltip title="En proceso" arrow>
                                    <button style={{ backgroundColor: isActiva4 }}
                                        onClick={e => handleMenuOptionDesk(pages[3], 3)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEye} /> <br />En proceso</button>
                                </Tooltip>
                                <Tooltip title="Aceptadas" arrow>
                                    <button style={{ backgroundColor: isActiva5 }}
                                        onClick={e => handleMenuOptionDesk(pages[4], 4)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faCheckDouble} /> <br />Aceptadas</button>
                                </Tooltip>
                                {/* <Tooltip title="Información Comercial" arrow>
                                    <button style={{ backgroundColor: isActiva6 }}
                                        onClick={e => handleMenuOptionDesk(pages[5], 5)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faIndustry} /> <br />Información Comercial</button>
                                </Tooltip> */}
                            </Fragment>
                        ) : props.idUsuario === 1 ?
                            <Fragment>
                                <span className='text-center textoEscondido'><strong> Bienvenido a COMERCAM en línea</strong></span>
                                <br className='textoEscondido'></br><br></br>
                                <Tooltip title="Borrador" arrow>
                                    <button style={{ backgroundColor: isActiva1 }} onClick={e => handleMenuOptionDeskBasic(pages[0], 0)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br /> Borrador</button>
                                </Tooltip>
                                <Tooltip title="Documentos pendientes" arrow>
                                    <button style={{ backgroundColor: isActiva2 }}
                                        onClick={e => handleMenuOptionDeskBasic(pages[1], 1)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faFilePdf} /> <br />Documentos pendientes</button>
                                </Tooltip>
                                <Tooltip title="Enviadas" arrow>
                                    <button style={{ backgroundColor: isActiva3 }}
                                        onClick={e => handleMenuOptionDeskBasic(pages[2], 2)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEnvelope} /> <br />Enviadas</button>
                                </Tooltip>

                                <Tooltip title="En proceso" arrow>
                                    <button style={{ backgroundColor: isActiva4 }}
                                        onClick={e => handleMenuOptionDeskBasic(pages[3], 3)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEye} /> <br />En proceso</button>
                                </Tooltip>

                                <Tooltip title="Aceptadas" arrow>
                                    <button style={{ backgroundColor: isActiva5 }}
                                        onClick={e => handleMenuOptionDeskBasic(pages[4], 4)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faCheckDouble} /> <br />Aceptadas</button>
                                </Tooltip>
                            </Fragment>
                            : ''
                        }
                        {props.idUsuario === 7 ?
                            <Fragment>
                                <span className='text-center textoEscondido'><strong>COMERCAM en línea consulta</strong></span>
                                <br className='textoEscondido'></br><br></br>
                            </Fragment>

                            : (<></>)
                        }
                    </div>
                    <Tooltip title="Salir de la aplicación" arrow>
                        <button style={{ border: 'none', padding: '4px', backgroundColor: '#2b2b2b', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                    </Tooltip>
                </header>
                <div style={{ overflow: 'scroll' }} className={`l-navbar ${claseNav}`} id='nav-bar'>
                    <nav className='nav'>
                        <div>
                            <a ref={myRef} onClick={agregarClasesToggle} href='#' className='a2 text-center' style={{ color: 'white', width: '30px' }}>

                                <Tooltip title="Abrir el menú de opciones" arrow>
                                    <div className={`bx `} id="header-toggle" style={{ width: '50px', marginTop: '50px; !important', textAlign: 'center', marginLeft: '4%' }}>
                                        <img id="imagenLogoMaguey" className="img-fluid" src={Menu} ></img>
                                    </div>
                                </Tooltip>

                            </a>
                            <div className='nav_list'>
                                <List style={{ backgroundColor: '#2b2b2b', color: 'white' }}>
                                    {props.idUsuario === 1 ?
                                        <Fragment>
                                            {serviciosConComercamRutasBasic.map((item, index) => (
                                                <NavLink key={index} exact to={item.ruta} className="nav_link" onClick={agregarClasesToggle}>
                                                    <Tooltip key={index} title={toolTips2[index].text} arrow>
                                                        <img src={serviciosConComercamRutasBasic[index].source} style={{ width: '50px' }} />

                                                    </Tooltip>
                                                    <span className="nav_name text-wrap">{item.text}</span>
                                                </NavLink>
                                            ))}
                                        </Fragment>
                                        : props.idUsuario === 2 ?
                                            <Fragment>
                                                <br />
                                                {serviciosPremium.map((item, index) => (
                                                    <NavLink key={index} className="nav_link" onClick={() => { cerrarToggle() }}
                                                        to={item.ruta}>
                                                        <Tooltip key={index} title={serviciosPremium[index].text} arrow>
                                                            <img src={serviciosPremium[index].source} style={{ width: '45px' }} />
                                                        </Tooltip>
                                                        <span className="nav_name text-wrap">{item.text}</span>
                                                    </NavLink>

                                                ))}
                                                <hr style={{ color: 'white', backgroundColor: 'white', height: '2px', margin: '10px 0' }} />
                                                <div style={{ color: '#CD973D', marginLeft: '10%' }}>
                                                    <img src={Solicitudes} style={{ width: '45px' }} /><b style={{ marginLeft: '10%' }}>SOLICITUDES</b></div>
                                                <hr style={{ color: 'white', backgroundColor: 'white', height: '2px', margin: '10px 0' }} />
                                                {serviciosConComercamRutasPremium.map((item, index) => (
                                                    item.modal ?

                                                        <NavLink key={index} className="nav_link" onClick={() => { cerrarToggle() }}
                                                            to={{
                                                                pathname: item.ruta, state: {
                                                                    mensaje: "Para este tipo de servicio es importante ampliar cadena productiva ante COMERCAM, a través de una solicitud de actualización.",
                                                                    titulo: 'Mensaje', modal: item.modal
                                                                }
                                                            }}>
                                                            <Tooltip key={index} title={serviciosConComercamRutasPremium[index].text} arrow>
                                                                <img src={serviciosConComercamRutasPremium[index].source} style={{ width: '45px' }} />
                                                            </Tooltip>
                                                            <span className="nav_name text-wrap">{item.text}</span>
                                                        </NavLink> :
                                                        <NavLink key={index} className="nav_link" onClick={() => { cerrarToggle() }}
                                                            to={item.ruta}>
                                                            <Tooltip key={index} title={serviciosConComercamRutasPremium[index].text} arrow>
                                                                <img src={serviciosConComercamRutasPremium[index].source} style={{ width: '45px' }} />
                                                            </Tooltip>
                                                            <span className="nav_name text-wrap">{item.text}</span>
                                                        </NavLink>
                                                ))}
                                                {/* <NavLink className="nav_link" onClick={() => { cerrarToggle() }} to="/informacion_comercial">
                                                    <Tooltip title="Información Comercial" arrow>
                                                        <div style={{ width: '45px', textAlign: 'center' }}>
                                                            <FontAwesomeIcon icon={faIndustry} style={{ fontSize: '24px', color: 'white' }} />
                                                        </div>
                                                    </Tooltip>
                                                    <span className="nav_name text-wrap">Información Comercial</span>
                                                </NavLink> */}
                                            </Fragment>
                                            : (props.idUsuario === 7) ?
                                                <Fragment >
                                                    {serviciosConComercamRutasConsulta.map((item, index) => (

                                                        <NavLink key={index} exact to={item.ruta} className="nav_link" onClick={agregarClasesToggle}>
                                                            <Tooltip key={index} title={serviciosConComercamRutasConsulta[index].text} arrow>
                                                                <img src={serviciosConComercamRutasConsulta[index].source} style={{ width: '45px', backgroundImage: '#CD973D' }} />
                                                            </Tooltip>
                                                            <span className="nav_name text-wrap">{item.text}</span>
                                                        </NavLink>

                                                    ))}
                                                </Fragment>
                                                : <></>
                                    }
                                </List>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>

            {props.componenteCerrarSesionModal}
        </Fragment>
    );
};
export default withRouter(MenuHamburguesaBebeficiario)
